<template>
  <div>
    <div class="d-flex align-center mb-2" style="gap: 10px">
      <label v-if="label" class="label-input mb-0">{{ label }}</label>
      <input type="checkbox" :checked="safeButton.show" @change="e => updateButton('show', !!e.target.checked)" />
    </div>
    <div :class="['group-item', wrapperClass]">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            :value="safeButton.text"
            label="Button Text"
            hide-details
            @input="value => updateButton('text', value)"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            :value="safeButton.link"
            label="Button Link"
            hide-details
            @input="value => updateButton('link', value)"
          />
        </v-col>
        <v-col cols="12" md="4">
          <ColorPicker
            :value="safeButton.backgroundColor"
            name="btn-background"
            label="Background"
            default-color="#606F99"
            @input="value => updateButton('backgroundColor', value)"
          />
        </v-col>
        <v-col cols="12" md="4">
          <ColorPicker
            :value="safeButton.color"
            name="btn-text-color"
            label="Text Color"
            default-color="#FFFFFF"
            @input="value => updateButton('color', value)"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="safeButton.radius"
            class="mt-2"
            type="number"
            label="Radius"
            min="0"
            suffix="px"
            hide-details
            dense
            @input="value => updateButton('radius', normalizeRadius(value))"
          />
        </v-col>
      </v-row>

      <div v-if="showIconPrefix" class="mt-4">
        <div class="font-weight-medium mb-2">Icon Prefix</div>
        <v-row>
          <v-col cols="12" md="4">
            <v-checkbox
              :input-value="safeButton.iconPrefix.show"
              label="Show icon prefix"
              hide-details
              class="mt-0"
              @change="value => updateIcon('iconPrefix', 'show', !!value)"
            />
          </v-col>
          <v-col cols="12" md="8">
            <UploadImage
              :image="{ imageSrc: safeButton.iconPrefix.src }"
              :height="`80`"
              :typeUpload="'image'"
              @callback="obj => updateIcon('iconPrefix', 'src', (obj && obj.imageSrc) || '')"
              @callbackDelete="() => updateIcon('iconPrefix', 'src', '')"
            />
          </v-col>
        </v-row>
      </div>

      <div v-if="showIconSuffix" class="mt-4">
        <div class="font-weight-medium mb-2">Icon Suffix</div>
        <v-row>
          <v-col cols="12" md="4">
            <v-checkbox
              :input-value="safeButton.iconSuffix.show"
              label="Show icon suffix"
              hide-details
              class="mt-0"
              @change="value => updateIcon('iconSuffix', 'show', !!value)"
            />
          </v-col>
          <v-col cols="12" md="8">
            <UploadImage
              :image="{ imageSrc: safeButton.iconSuffix.src }"
              :height="`80`"
              :typeUpload="'image'"
              @callback="obj => updateIcon('iconSuffix', 'src', (obj && obj.imageSrc) || '')"
              @callbackDelete="() => updateIcon('iconSuffix', 'src', '')"
            />
          </v-col>
        </v-row>
      </div>

      <div v-if="showSubBtn" class="mt-4">
        <div class="font-weight-medium mb-2">Sub Button</div>
        <v-row>
          <v-col cols="12" md="4">
            <v-checkbox
              :input-value="safeButton.subBtn.show"
              label="Show sub button"
              hide-details
              class="mt-0"
              @change="value => updateSubBtn('show', !!value)"
            />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              :value="safeButton.subBtn.text"
              label="Sub Button Text"
              hide-details
              @input="value => updateSubBtn('text', value)"
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './color-picker.vue';

const defaultButton = {
  show: true,
  backgroundColor: '#606F99',
  color: '#FFFFFF',
  radius: 4,
  text: 'Shop Now',
  link: '#',
  iconPrefix: {
    show: false,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  subBtn: {
    show: false,
    text: '30-Day Money-Back Guararantee',
  },
};

export default {
  name: 'ButtonPrimary',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    button: {
      type: Object,
      required: true,
      default: () => ({ ...defaultButton }),
    },
    label: {
      type: String,
      default: 'Button',
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    showIconPrefix: {
      type: Boolean,
      default: true,
    },
    showIconSuffix: {
      type: Boolean,
      default: true,
    },
    showSubBtn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    safeButton() {
      const src = this.button || {};
      return {
        ...defaultButton,
        ...src,
        iconPrefix: { ...defaultButton.iconPrefix, ...(src.iconPrefix || {}) },
        iconSuffix: { ...defaultButton.iconSuffix, ...(src.iconSuffix || {}) },
        subBtn: { ...defaultButton.subBtn, ...(src.subBtn || {}) },
      };
    },
  },
  methods: {
    emitChange() {
      this.$emit('update:button', this.button);
      this.$emit('change', this.button);
    },
    updateButton(key, value) {
      this.$set(this.button, key, value);
      this.emitChange();
    },
    updateIcon(slot, key, value) {
      if (!this.button[slot]) this.$set(this.button, slot, { ...defaultButton[slot] });
      this.$set(this.button[slot], key, value);
      this.emitChange();
    },
    updateSubBtn(key, value) {
      if (!this.button.subBtn) this.$set(this.button, 'subBtn', { ...defaultButton.subBtn });
      this.$set(this.button.subBtn, key, value);
      this.emitChange();
    },
    normalizeRadius(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0) return 0;
      return num;
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
</style>
